import React, { useState } from "react";
import { Card, CardContent, Grid, Typography } from "@material-ui/core";
import { useEffect } from "react";
import { read } from "Helpers/LocalStorage";
import HomeService from "Services/http/endpoints/home/HomeService";
import StatusHandler from "Helpers/StatusHandler";
import Translator from "Languages/Utility/Translator";
import { Skeleton } from "@material-ui/lab";

export default function SmallCountShow() {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      const params = {
        KeyGroup: read("groupAKey"),
        KeyUser: read("userAKey"),
        IsAdminP: true,
      };
      const response = await HomeService.getCount(params);
      let err = StatusHandler(response);
      if (!err.isFail) setData(response.data.Value);
    })();
  }, []);

  return (
    <Grid container spacing={2}>
      {data ? (
        data.map((item, index) => {
          return (
            <Grid item sm={4} xs={12} key={item.id}>
              <Card className={`staticCard box-${index}`}>
                <CardContent className="infoSection">
                  <span>
                    <Translator id={item.title} />
                  </span>
                  <Typography variant="body2" component="p" className="mt-2">
                    {item.value}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          );
        })
      ) : (
        <>
          <Grid item sm={4} xs={12}>
            <Skeleton
              variant="text"
              animation="wave"
              height={120}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Skeleton
              variant="text"
              animation="wave"
              height={120}
            />
          </Grid>
          <Grid item sm={4} xs={12}>
            <Skeleton
              variant="text"
              animation="wave"
              height={120}
            />
          </Grid>
        </>
      )}
    </Grid>
  );
}
